import { render } from "./TemplateRow.vue?vue&type=template&id=2b30b512"
import script from "./TemplateRow.vue?vue&type=script&lang=js"
export * from "./TemplateRow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\0my-projects\\myweb2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__